import {useState} from "react";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import IconButton from '@mui/material/IconButton';
import FeaturedPlayListIcon from '@mui/icons-material/FeaturedPlayList';
import GetGuideDesipramine from "./GetGuideDesipramine";

export default function Dia_desipramine() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};

return(
<>      
    <IconButton onClick={handleOpen} size="small" >
            <FeaturedPlayListIcon sx={{fontSize: '110%', color: 'traffic.orange', '&:hover': { color: 'primary.light'}, }}/>
    </IconButton>

    <CustomDialog open={open} onClose={handleClose}

        title="Desipramine - Clinical Guidelines"
        content={ <GetGuideDesipramine />}

    />

</>
)}